import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
import { ElIcon } from 'element-plus';
import { CircleCheckFilled, CopyDocument } from '@element-plus/icons-vue';
import AdCard2 from '@/components/tip/AdCard2';
import { readContract } from '@wagmi/core';
import StakingPoolABI from "@/utils/abi/StakingPool.json";
import { contracts } from "@/utils/contracts/config";
import { BigNumber } from "ethers";
import { loutsRpc, retryFun, walletProvider } from "@/utils/LoutsRpc";
import { ChainHead, ChainReadObj, StateAccountKey, StateGetActor } from "@/utils/FilecoinApi";
import { decode as dagCborDecode } from "@ipld/dag-cbor";
import { newAddressFromBytes } from "@/utils/contracts/singer/filecoin_utils";
import { encode, encode as addressToString, newDelegatedEthAddress } from "@glif/filecoin-address";
import Singer from '@/components/induction/singer/Singer';
import { getPrefix, NotificationErr } from "@/utils/common";
import Tip from '@/components/tip/Tip';
import Clipboard from "clipboard";
export default {
  name: "SetOperator",
  components: {
    CopyDocument,
    ElIcon,
    AdCard2,
    Singer,
    Tip
  },
  data() {
    return {
      radio1: 'Node Owner',
      CircleCheckFilled,
      active: 1,
      sendProposal: false,
      approvedProposalRes: false,
      inputs: {
        input1: 'f01234',
        input2: 0,
        input3: 10101
      },
      radio2: 'Content',
      singerTables: [],
      contractParams: [],
      contractMethod: 'approveOperator',
      changeAddress: '',
      nodeRole: 'Owner',
      singerMultiple: false,
      newOperator: '',
      affirmOperator: false,
      loading: false,
      showNewOperator: false,
      showCurrentOperator: false,
      isHaveActorId: true,
      isCopy: false
    };
  },
  props: {
    nodeId: {
      type: String,
      default: ''
    }
  },
  created() {
    this.showCurrentOperator = this.currentNode.operator !== '0x0000000000000000000000000000000000000000';
    if (!this.showCurrentOperator) {
      this.showNewOperator = true;
    }
  },
  methods: {
    async init() {
      await this.getNode();
      try {
        this.initActorState();
      } catch (e) {
        NotificationErr("Network request error, please try again!");
      }
    },
    viewNode() {
      this.$router.push({
        path: '/farm/provider/' + this.nodeId
      });
    },
    getNetworkPrefix() {
      let prefix = '';
      if (this.env === 'test') {
        prefix = 't';
      } else {
        prefix = 'f';
      }
      return prefix;
    },
    initActorState() {
      loutsRpc(StateGetActor(this.nodeInfo.owner)).then(res => {
        loutsRpc(ChainReadObj(res.result.Head)).then(async res => {
          let stateRawbytes = Uint8Array.from(Buffer.from(res.result, 'base64'));
          let msgSigState = dagCborDecode(stateRawbytes);
          // 有更简单的直接调用api接口得方式
          let signersRawbytes = msgSigState[0];
          if (Array.isArray(signersRawbytes)) {
            let head = loutsRpc(ChainHead());
            this.$store.commit('SET_SINGER_MULTIPLE_THRESHOLD', {
              singerMultipleThreshold: signersRawbytes.length
            });
            this.$store.commit('SET_SINGER_MULTIPLE_NUM', {
              singerMultipleNum: msgSigState[1]
            });
            this.singerTables = [];
            for (let i = 0; i < signersRawbytes.length; i++) {
              let signerBytes = signersRawbytes[i];
              let signerIdAddress = newAddressFromBytes(signerBytes);
              let idAddressStr = addressToString(getPrefix()[0], signerIdAddress);
              let nonIdAddressStr = await loutsRpc(StateAccountKey(idAddressStr, head.Cids)); // 测试网用t, 主网用f
              this.singerTables.push({
                isOk: false,
                isCheck: false,
                address: nonIdAddressStr.result,
                id: idAddressStr,
                index: i
              });
            }
            this.singerMultiple = true;
          } else {
            this.singerMultiple = false;
          }
          setTimeout(() => {
            this.contractParams = [];
            this.contractParams.push(this.nodeId, this.newOperator);
            this.$refs['singer'].init();
          }, 100);
        });
      });
    },
    async getNode() {
      const data = await readContract({
        address: contracts[this.env].StakingPool.eth,
        abi: StakingPoolABI.abi,
        functionName: 'getNodeData',
        args: [this.nodeId]
      });
      let _nodeInfo = {
        id: '',
        beneficiary: '',
        owner: '',
        ownerAddress: '',
        beneficiaryAddress: ''
      };
      let role = data[0].role;
      let owner = '';
      if (role === 1) {
        // eslint-disable-next-line no-undef
        owner = getPrefix() + (BigNumber.from(data[0].owner).toBigInt() & BigInt("0x00000000000000000000000000000FFFFFFFFFFF")).toString();
      } else {
        let minerInfo = await retryFun(() => walletProvider.minerInfo(this.getNetworkPrefix() + '0' + this.nodeId.toString()), 3);
        console.log('minerInfo', minerInfo);
        let nowOwner = minerInfo.Owner.toString().substr(2);
        owner = this.getNetworkPrefix() + '0' + nowOwner;
      }
      _nodeInfo.id = this.nodeId;
      this.contractMethod = 'approveOperator';
      _nodeInfo.owner = owner;
      this.$store.commit('SET_NODE_INFO', _nodeInfo);
    },
    pushProposalNext() {
      this.active++;
    },
    connectWallet() {
      this.$store.state.refs['iHeader'].connectWallet();
    },
    setCurrentWallet() {
      this.newOperator = this.address;
    },
    copy() {
      let clipboard = new Clipboard('.copy-text', {
        text: () => {
          return this.currentNode.operator;
        }
      });
      clipboard.on('success', () => {
        this.isCopy = true;
        setTimeout(() => {
          this.isCopy = false;
        }, 1500);
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.isCopy = false;
        clipboard.destroy();
      });
    },
    sendProposalFun() {
      this.sendProposal = true;
      this.active++;
      this.$nextTick(() => {
        this.$refs['singer2'].init();
      });
    },
    approvedProposal() {
      this.active++;
    },
    approvedProposal2() {
      this.approvedProposalRes = true;
    },
    reapprove() {
      this.showNewOperator = true;
    },
    async checkEthAddress() {
      if (!this.newOperator.toLowerCase().startsWith("0x") || this.newOperator.length !== 42) {
        NotificationErr('Invalid Address!');
        return true;
      }
      let f4Address = encode("f", newDelegatedEthAddress(this.newOperator));
      try {
        let upId = await retryFun(() => walletProvider.lookupId(f4Address), 3);
        if (!upId) {
          this.isHaveActorId = false;
          return true;
        }
      } catch (err) {
        this.isHaveActorId = false;
        return true;
      }
      this.isHaveActorId = true;
      return false;
    },
    async affirm() {
      if (this.newOperator === '') {
        NotificationErr('Please enter operator');
        return;
      }
      this.newOperator = this.newOperator.toString().trim();
      this.loading = true;
      if (await this.checkEthAddress()) {
        this.loading = false;
        return;
      }
      await this.init();
      this.affirmOperator = true;
      this.showCurrentOperator = false;
      this.loading = false;
    }
  },
  computed: {
    env() {
      return this.$store.state.evn;
    },
    currentNode() {
      return this.$store.state.nodeData.currentNode;
    },
    singerMultipleNum() {
      return this.$store.state.node.singerMultipleNum;
    },
    singerMultipleThreshold() {
      return this.$store.state.node.singerMultipleThreshold;
    },
    nodeInfo() {
      return this.$store.state.node.nodeInfo;
    },
    isConnected() {
      return this.$store.state.isConnected;
    },
    address() {
      return this.$store.state.address;
    }
  }
};